import axios from "axios";
import {toast} from "../class/Notification";
import router from "@/router";
import store from "@/store";
import {findObjectIndex} from "../class/Converter";

export let DeliveryTypes = [
    {value: "brand", text: "برند"},
    {value: "category", text: "دسته بندی"},
];


const deliveryDataShape = (form) => {
    if (form.percent_per_item == '') {
        delete form['percent_per_item'];
    }
    return form;
}


export default {
    namespaced: true,
    state: {
        deliveries: [],
        meta: {},
    },
    mutations: {
        setDeliveries: (state, deliveries) => {
            state.deliveries = deliveries
        },
        setMeta: (state, meta) => {
            state.meta = meta
        },
        deleteItem(state, delivery) {
            state.deliveries.splice(findObjectIndex(store.getters['Delivery/getDeliveries'], delivery), 1)
        }
    },
    actions: {
        getDeliveries({commit}, page = 1) {
            axios.get(`delivery?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setDeliveries', res.data)
                    commit('setMeta', res.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteDelivery({commit}, delivery) {
            axios.delete(`delivery/${delivery.id}`)
                .then(res => {
                    const delivery = res.data.data;
                    commit('deleteItem', delivery)
                })
        },
        createDelivery({commit}, form) {
            form = deliveryDataShape(form)
            axios.post(`/delivery`, form)
                .then(res => {
                    const delivery = res.data.data;
                    router.push({name: 'UpdateDelivery', params: {id: delivery.id}})
                    toast('آدرس با موفقیت ثبت شد ', 'نرخ با موفقیت ثبت شد ')
                })
        },
        updateDelivery({commit}, form) {
            form = deliveryDataShape(form)
            axios.put(`delivery/${form.id}`, form)
                .then(res => {
                    const delivery = res.data.data;
                    toast('عملیات با موفقیت انجام شد', 'به روز رسانی نرخ موفقیت انجام شد')
                })
        },
        setDelivery({commit}, form) {
            return axios.get(`delivery/${form.id}`)
        },
        //todo move delivery price from shopping cart to here
        getDeliveryBaseOnLocationConfig({commit}) {
            return axios.get(`delivery-price-base-on-location`)
        },
        updateDeliveryBaseOnLocationConfig({commit}, form) {
            return axios.post(`delivery-price-base-on-location`, form)
        },
        storeOrderDeliveryLocation({commit}, form) {
            return axios.post(`delivery-price-base-on-location/order/${form.order_id}`,form)
        },

    },
    getters: {
        getDeliveries: (state) => state.deliveries.filter(item => {
            return item.deliverables != null
        }),
        getMeta: (state) => state.meta,
    }
}